function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
const createInvariantWithPrefix = function () {
  let errorPrefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[prefix]: ';
  return function (condition) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Invariant failed';
    if (!condition) {
      throw new Error(errorPrefix + message);
    }
  };
};
const memoize = function (fn) {
  let map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const key = JSON.stringify(args);
    if (!map.has(key)) {
      map.set(key, fn(...args));
    }
    return map.get(key);
  };
};
const get = (o, path, defaultValue) => {
  const _ref = typeof path === 'string' ? path.replace(/\[(\d+)]/g, '.$1').split('.') : path,
    _ref2 = _toArray(_ref),
    head = _ref2[0],
    tail = _ref2.slice(1);
  if (!o[head]) return defaultValue;
  return !tail.length ? o[head] : get(o[head], tail, defaultValue);
};
module.exports = {
  createInvariantWithPrefix,
  memoize,
  get
};